import { Injectable } from '@angular/core';
import { HttpHeaders, HttpClient } from '@angular/common/http';
import { Release } from '../Models';
import { Tenant } from '../../../../Models/tenant';

@Injectable({
    providedIn: 'root'
})
export class ReleaseService {
    apiUrl = '/api/release/';  // URL to web api

    constructor(private http: HttpClient) {
    }

    getReleases(tenant: Tenant): Promise<Release[]> {
        console.log("Fetching releases : " + tenant.TenantId);
        return this.http.get<Release[]>(this.apiUrl + "get/" + tenant.TenantId)
            .toPromise()
            .then(response => {
                return response as Release[];
            })
            .catch(this.handleError);
    }

    getRelease(tenant: Tenant, releaseNumber: number): Promise<Release> {
        return this.http.get<Release>(this.apiUrl + "get/" + tenant.TenantId + "/" + releaseNumber)
            .toPromise()
            .then(response => {
                return response as Release;
            })
            .catch(this.handleError);
    }

    createRelease(tenant: Tenant, release: Release): Promise<any> {
        console.log("Creating a release : " + tenant.TenantId + release.Packages.length);

        let headers = new HttpHeaders({ 'Content-Type': 'application/json' });
        let options = { headers: headers };

        return this.http
            .post(this.apiUrl + "create/" + tenant.TenantId, release, options)
            .toPromise()
            .then((data) => {
                console.log("Posted data to release controller ok");
                return data;
            })
            .catch(this.handleError);
    }

    publish(tenant: Tenant, releaseNumber: Number): Promise<any> {
        console.log("Publishing a release : " + tenant.TenantId + releaseNumber);

        let headers = new HttpHeaders({ 'Content-Type': 'application/json' });
        let options ={ headers: headers };

        return this.http
            .post(this.apiUrl + "publish/" + tenant.TenantId + "/" + releaseNumber, "", options)
            .toPromise()
            .then(() => {
                console.log("Posted data to release controller ok");
            })
            .catch(this.handleError);
    }

    private handleError(error: any): Promise<any> {
        console.error('An error occurred', error); // for demo purposes only
        return Promise.reject(error.message || error);
    }
}
